var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import styles from './ExternalWitnessDialog.module.css';
import { Button, ButtonVariant } from '../Components/Button';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { CloseIcon } from '../Components/Icons';
import { MaskedTextField } from '../Components/MaskedTextField';
import { StyledDialog } from '../Components/Dialog/StyledDialog';
import { StyledDialogButton } from '../Components/Dialog/StyledDialogButton';
import { StyledDialogContent } from '../Components/Dialog/StyledDialogContent';
import { white50 } from '../Styles/Colours';
import classNames from 'classnames';
export var ExternalWitnessDialog = function (props) {
    var _a;
    var _b = __read(useState(props.initialName), 2), name = _b[0], setName = _b[1];
    var _c = __read(useState(false), 2), nameError = _c[0], setNameError = _c[1];
    var _d = __read(useState(''), 2), contactDetails = _d[0], setContactDetails = _d[1];
    var _e = __read(useState(false), 2), contactDetailsError = _e[0], setContactDetailsError = _e[1];
    var _f = __read(useState(false), 2), acknowledged = _f[0], setAcknowledged = _f[1];
    var _g = __read(useState(false), 2), acknowledgedError = _g[0], setAcknowledgedError = _g[1];
    function closeDialog(save) {
        props.onClose(save, name, contactDetails);
    }
    function setTextAndValidate(value, valueSetter, errorState, errorSetter) {
        valueSetter(value);
        if (errorState && value.trim().length > 0) {
            errorSetter(false);
        }
    }
    function toggleAcknowledged() {
        var newAcknowledged = !acknowledged;
        setAcknowledged(newAcknowledged);
        if (acknowledgedError && newAcknowledged)
            setAcknowledgedError(false);
    }
    var checkContinue = function () {
        var valid = true;
        var trimmedName = name.trim();
        if (trimmedName.length < 1) {
            setNameError(true);
            valid = false;
        }
        var trimmedContactDetails = contactDetails.trim();
        if (trimmedContactDetails.length < 1) {
            setContactDetailsError(true);
            valid = false;
        }
        if (!acknowledged) {
            setAcknowledgedError(true);
            valid = false;
        }
        if (!valid) {
            return;
        }
        closeDialog(true);
    };
    return (React.createElement(StyledDialog, { open: true, size: 'xs', testId: 'external-witness-dialog', title: 'Record an external witness', titleBarRight: React.createElement(Button, { iconOnly: true, onClick: function () { return closeDialog(false); }, noShadowOnHover: true, subtleShadeOnHover: true, testId: 'external-witness-dialog-button-close', tooltip: 'Close' },
            React.createElement(CloseIcon, { size: '20', color: white50, noPadding: true })), actions: React.createElement(React.Fragment, null,
            React.createElement(StyledDialogButton, { variant: ButtonVariant.light, key: 'cancel', width: 104, onClick: function () { return closeDialog(false); }, testId: 'external-witness-dialog-button-cancel' }, "Cancel"),
            React.createElement(StyledDialogButton, { variant: ButtonVariant.primary, key: 'save', width: 104, onClick: checkContinue, testId: 'external-witness-dialog-button-save' }, "Save")), contentComponent: React.createElement(StyledDialogContent, { noPadding: true },
            React.createElement("div", { className: styles.contentContainer },
                React.createElement("div", { className: styles.fieldContainer },
                    React.createElement(MaskedTextField, { value: name, onChange: function (value) { return setTextAndValidate(value, setName, nameError, setNameError); }, testId: 'external-witness-name-text', label: 'Full name', errorText: nameError ? 'Required' : undefined, required: true })),
                React.createElement("div", { className: styles.fieldContainer },
                    React.createElement(MaskedTextField, { value: contactDetails, onChange: function (value) {
                            return setTextAndValidate(value, setContactDetails, contactDetailsError, setContactDetailsError);
                        }, testId: 'external-witness-contact-details-text', label: 'Contact details', errorText: contactDetailsError ? 'Required' : undefined, helperText: 'Enter a phone number, email address or residential address', required: true })),
                React.createElement("div", { className: styles.acknowledgedFieldContainer },
                    React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { checked: acknowledged, onChange: toggleAcknowledged, className: classNames(styles.acknowledged, (_a = {},
                                _a[styles.error] = acknowledgedError,
                                _a)) }), label: 'I acknowledge that I have read, understand, and agree to the policies and procedures of being a Witness for recording medication.' })),
                React.createElement("div", { className: styles.acknowledgedFieldError }, acknowledgedError ? 'Required' : ''))) }));
};
